<template>
  <div id="app">
    <Header />
    <router-view />
    <screenshot></screenshot>
    <Foot />
  </div>
</template>

<script>
import Header from '@/components/Common/Header'
import Foot from '@/components/Common/Foot'
import Screenshot from "./screenshot";

export default {
  name: 'App',
  components: {
    Screenshot,
    Header,
    Foot
  }
}
</script>

<style>
.el-breadcrumb {
  /* margin-top: 9px; */
  line-height: inherit !important;
}
</style>

<style scoped>
#app {
  background: #fff;
  /* background:#f5f5f5; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue